import "./QuestionMarkTooltip.css";

import { Help } from "./Vectors";

export default function QuestionMarkTooltip() {
  return <Help className="QuestionMarkTooltip action-link" width={20} />;
}
